import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useIsSuperAdmin } from '@/lib/api/superadmin';

/**
 * Route guard for super admin-only pages
 * Redirects to dashboard if user is not a super admin
 */
export function SuperAdminRoute() {
  const { isAuthenticated, isLoading: authLoading, user } = useAuthStore();
  const { data: isSuperAdmin, isLoading: superAdminLoading } = useIsSuperAdmin();

  // Show loading while checking authentication and super admin status
  if (authLoading || superAdminLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-content-secondary">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to dashboard if not super admin
  if (!isSuperAdmin) {
    console.warn('Non-super-admin user attempted to access super admin route:', user?.email);
    return <Navigate to="/dashboard" replace />;
  }

  // User is authenticated and is super admin
  return <Outlet />;
}
